import { Component, OnInit } from "@angular/core";
import { RestService } from "../services/rest.service";

@Component({
  selector: "app-thank",
  standalone: false,
  templateUrl: "./thank.component.html",
})
export class ThankComponent implements OnInit {
  constructor(
    private rest: RestService
  ) { }
  user: any = {}
  requestDetails: any = {}
  idRequest = ''
  ngOnInit(): void {
    this.rest.setToken(localStorage.getItem('token') ?? '')
    this.idRequest = window.location.pathname.split('/')[2]
    this.getDetails()
  }

  getDetails() {
    this.rest.get(`/client-request/${this.idRequest}/external-review`).subscribe({
      next: (value: any) => {
        value.reserveDate = new Date(value.reserveDate).toLocaleDateString()
        this.requestDetails = value
      },
      error: () => { }
    })
  }

  returnToSite() {
    window.location.href = this.requestDetails?.returnUrl ?? '/'
  }
}
